import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { HorizontalOptions } from '@cmps/ng-chart';
import { TranslateService } from '@ngx-translate/core';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { MyPerformanceVsPeers } from './my-performance-vs-peers.widget.model';
import { PillarPerformanceWidgetComponent } from './pillar-performance.widget.component';

@Component({
    selector: 'cmps-widget-my-performance-vs-peers',
    templateUrl: './my-performance-vs-peers.widget.component.html',
})
export class MyPerformanceVsPeersWidgetComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    options: HorizontalOptions;
    data: MyPerformanceVsPeers;
    private _modal: NgbModalRef;

    // TODO revise
    private _showGoToDashboardButton: boolean;
    private _kpiIds: number[];

    constructor(
        private readonly _modalService: NgbModal,
        private readonly _translateService: TranslateService,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _service: LegacyWidgetService,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this.options = {
            rect: { width: '100%', height: 200, top: 10, right: 20 },
            showYAxisPath: false,
            showLegend: true,
            xAxis: (xAxis) => xAxis.ticks(5),
            color: (d) => {
                return d.index === 0
                    ? d.y > 0
                        ? '#75c743'
                        : '#ea5562'
                    : '#6e7277';
            },
            legend: {
                color: (d, i) => (i === 0 ? ['#75c743', '#ea5562'] : '#6e7277'),
            },
        };

        this.hasPendingData = true;
        this._service.myPerformanceVsPeers().subscribe(
            (data) => {
                data.d3.data[0].key = this._translateService.instant(
                    TranslationKeyMap._764_YOU__BASED_ON_YOUR_PERFORMANCE,
                );
                data.d3.data[1].key = this._translateService.instant(
                    TranslationKeyMap._765_PEERS__BASED_ON_YOUR_CURRENT_SUPERGROUP_PERFORMANCE,
                );
                this.data = data;
            },
            // eslint-disable-next-line n/handle-callback-err, no-return-assign
            (error) => (this.hasPendingData = false),
            // eslint-disable-next-line no-return-assign
            () => (this.hasPendingData = false),
        );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    // TODO revise
    private _evalAttributes(): void {
        this._kpiIds = [];
        this.config.attributes
            .filter((attr) => attr.name)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                // if (attr.name === 'displayallpillars')
                // if (attr.name === 'displayvariance')
                // if (attr.name === 'format')
                // if (attr.name === 'includeqtr')
                // if (attr.name === 'includesg')
                // if (attr.name === 'showdateselector')
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
                // if (attr.name === 'timeframe')
                if (attr.name.startsWith('kpiid')) {
                    if (attr.value == null || attr.value.length === 0) return;
                    this._kpiIds.push(parseInt(attr.value));
                }
            });
    }

    showDetails(): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            size: 'lg',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: PillarPerformanceWidgetComponent,
            options: {
                hasDetails: this._showGoToDashboardButton,
                definitionId: this.config.definitionId,
                pillarIds: this._kpiIds,
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
